<template>
  <div>
    <cms-programs
      v-if="programsSetUp"
      :theme="programOptions"
      :content="homepage.programs[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewPrograms' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const homepage = computed(() => mainStore.homepage);
const theme = computed(() => mainStore.theme);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const programOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('programs'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const programsSetUp = computed(() => !isEmpty(homepage.value?.programs?.[id.value]?.content));
</script>
